<template>
    <body class="bg-white" id="navigater-header">
        <div v-if="isSmallScreen">
            <CommonHeader></CommonHeader>
            <div class="mainboy flex flex-col w-full px-4 mx-auto pt-[70px]">
                <!-- Header -->
                <div class="mt-2">
                    <h1 class="news_detail_title text-xl font-bold text-gray-800 leading-tight mb-3">
                        {{newInfo && newInfo.title}}
                    </h1>
                    <div class="news_detail_info border-b border-gray-200 pb-3">
                        <div class="news_detail_info_left">
                            <span class="news_detail_info_item text-gray-500 text-sm">
                                {{newInfo && newInfo.realse_at.substring(0, 10)}}
                            </span>
                        </div>
                    </div>
                </div>
                <img v-if="newInfo && newInfo.cover_path" class="news_item_img  max-w-[372px] object-cover" :src="newInfo.cover_path" />
                <!-- Content -->
                <div class="mt-3 text-base leading-relaxed" v-html="newInfo && newInfo.content_path"></div>

                <!-- Footer -->
                <div class="flex flex-col mt-6">
                    <!-- Tags -->
                    <div class="flex flex-row flex-wrap gap-2 border-t border-gray-200 pt-6" v-if="newInfo">
                        <div v-for="tag in newInfo.tags.split(',')" :key="tag"
                             class="border border-gray-200 rounded-lg px-3 py-1 bg-blue-300 text-white">
                            <a href="#" target="_blank" class="text-gray-600 text-xs">{{tag}}</a>
                        </div>
                    </div>

                    <div class="w-full mt-6 border-t border-gray-200 pt-6" v-if="nextUrl">
                        <div class="text-gray-700 text-sm">
                            <span class="font-medium">下一篇</span>
                            <a :href="nextUrl" class="block mt-2 text-blue-600 truncate">{{nextTitle}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <transition name="fade">
                <button v-if="showScrollButton"
                        class="fixed bottom-6 right-4 w-10 h-10 rounded-full bg-blue-500 shadow-md cursor-pointer flex items-center justify-center text-white
                   transform transition-transform duration-300 hover:scale-105 active:scale-95"
                        @click="scrollToTop"
                        aria-label="回到顶部">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="20" height="20">
                        <path d="M12 4l-8 8h5v8h6v-8h5z" />
                    </svg>
                </button>
            </transition>
        </div>
        <div v-else>
            <div class="max-w-7xl mx-auto py-3 px-4 sm:px-16 lg:px-8">
              
                <CommonHeader></CommonHeader>
            </div>
            <div class="mainboy  flex flex-col w-[70%]  mx-auto">
                <!-- header -->
                <div class="">
                    <h1 class="news_detail_title text-2xl text-gray-800 h-16">
                        {{newInfo && newInfo.title}}
                    </h1>
                    <div class="news_detail_info border-b border-gray-300 ">
                        <div class="news_detail_info_left mb-4">
                            <span class="news_detail_info_item text-gray-400">
                                {{newInfo && newInfo.realse_at.substring(0, 10)}}
                            </span>
                        </div>
                    </div>
                </div>
                <img v-if="newInfo && newInfo.cover_path" class="news_item_img  max-w-[372px] object-cover" :src="newInfo.cover_path" />
                <!-- info -->
                <div class=" mt-3 " v-html="newInfo &&newInfo.content_path"></div>
                <!-- foot -->
                <div class="flex flex-col">
                    <div class="flex  gap-3  border-t  py-10  border-gray-300 w-full" v-if="newInfo">
                        <div v-for="tag in newInfo.tags.split(',')" :key="tag" class=" border border-gray-300 rounded ">
                            <a href="#" target="_blank" class="p-[10px] text-gray-800" style="font-size:12px ;color:#999999">{{tag}}</a>
                        </div>
                    </div>
                    <div class="w-full">
                        <div class="text-gray-800" v-if="nextUrl">
                            <span>下一篇</span>
                            <a href="nextUrl" class="pl-10">{{nextTitle}}</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 返回顶部悬浮球 -->
            <transition name="fade">
                <svg v-if="showScrollButton"
                     class="fixed bottom-8 right-8 w-12 h-12 rounded-full bg-blue-500 shadow-lg cursor-pointer flex items-center justify-center text-white
                        transform transition-transform duration-300 hover:-translate-y-2"
                     @click="scrollToTop"
                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                    <title>回到顶部</title>
                    <rect width="48" height="48" rx="24" ry="24" fill="rgba(101, 132, 251, 1)"></rect>
                    <path d="M31.71,26.3l-7-7a1,1,0,0,0-1.4,0l-7,7a1,1,0,0,0,1.4,1.4L24,21.39l6.31,6.31a1,1,0,0,0,1.4-1.4Z" fill="#fff" fill-rule="evenodd"></path>
                </svg>
            </transition>
        </div>
    </body>
</template>
<script>
    import CommonHeader from './subassembly/CommonHeader.vue';
import axios from 'axios';
/*import { jwtDecode } from 'jwt-decode';*/

    export default {
        components: {
            CommonHeader,
        },
    name: 'HomePage',
    metaInfo: {
        title: '识心智能 - 新闻动态',
        meta: [
            {
                name: 'description',
                content: '识心智能官网，各行各业量身定制专属的智能心理健康解决方案，以AI科技的力量促进心理健康事业的创新与繁荣发展'
            },
            {
                name: 'keywords',
                content: '识心智能, 心理健康, 心理健康AI, 心理AI, 健康AI, 心理健康方案, 声音疗愈, 智慧校园, 校园心理, 咨询师AI助手'
            }
        ]
    },

    data() {
        return {
            tags: "1,2,3,4",
            showMenu: false,
            showScrollButton: false,
            hovering: false,
            release_time:"",
            title:"",
            nextTitle:"",
            nextUrl: "",
            newsId: null,
            newInfo: null,
        }
    },
    
    methods: {        
        handleScroll() {
            this.showScrollButton = window.scrollY > 30
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // 平滑滚动
            })
            // 滚动完成后隐藏按钮（可选）
            setTimeout(() => {
                this.showScrollButton = false
            }, 1000)
        },
        async getPageInfo() {
            try {
                const response = await axios.get(`/api/news/get/${this.newsId}`, {});
                if (response.status == 200) {
                    this.newInfo = response.data.info;
                }
            } catch (error) {
                console.error('Failed to get :', error);
            }
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
        this.newsId = localStorage.getItem('newsid');
        if (this.newsId) {
            this.getPageInfo();
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    created() {

    }
};
</script>

<style>
    @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@400;500;700&display=swap');
    @import url('https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css');

</style>
